/**
 * Copyright 2017 OpenStack Foundation
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 * http://www.apache.org/licenses/LICENSE-2.0
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * */

import { LOGOUT_USER } from "openstack-uicore-foundation/lib/security/actions";
import {
  RECEIVE_SPONSOR_FORM,
  REQUEST_SPONSOR_FORM
} from "../actions/sponsor-actions";
import {
  RECEIVE_CART_FORM,
  REQUEST_CART_FORM
} from "../actions/checkout-actions";
import { formatDate } from "../utils/methods";
import { DATE_FORMAT } from "../utils/constants";

const DEFAULT_STATE = {
  form: null
};

const sponsorFormReducer = (state = DEFAULT_STATE, action) => {
  const { type, payload } = action;

  switch (type) {
    case REQUEST_SPONSOR_FORM:
    case REQUEST_CART_FORM:
    case LOGOUT_USER:
      return DEFAULT_STATE;
    case RECEIVE_SPONSOR_FORM: {
      const form = mapFormData(payload.response);

      return {
        ...state,
        form
      };
    }
    case RECEIVE_CART_FORM: {
      const form = mapFormData(payload.response);

      return {
        ...state,
        form
      };
    }
    default:
      return state;
  }
};

const mapFormData = (form) => ({
  ...form,
  opens_at: form.opens_at ? formatDate(form.opens_at, "UTC", DATE_FORMAT) : "-",
  expires_at: form.expires_at
    ? formatDate(form.expires_at, "UTC", DATE_FORMAT)
    : "-"
});

export default sponsorFormReducer;
